import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=65168ff3&scoped=true&"
import script from "./cropper.vue?vue&type=script&lang=js&"
export * from "./cropper.vue?vue&type=script&lang=js&"
import style0 from "./cropper.vue?vue&type=style&index=0&id=65168ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65168ff3",
  null
  
)

component.options.__file = "cropper.vue"
export default component.exports